(() => {
  window.phPhotoLeaves?.abort();
  const controller = new AbortController();
  window.phPhotoLeaves = controller;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const enhance = (root = document) => {
    if (motion.matches) return;
    const photos = root.querySelectorAll('.ph-autumn-window__scene, .ph-glass-media');
    photos.forEach(photo => {
      if (!photo.querySelector('img') || photo.querySelector('.ph-photo-leaf')) return;
      const leaf = document.createElement('span');
      leaf.className = 'ph-photo-leaf';
      leaf.setAttribute('aria-hidden', 'true');
      photo.appendChild(leaf);
    });
  };
  const options = {signal: controller.signal};
  document.addEventListener('shopify:section:load', event => enhance(event.target), options);
  motion.addEventListener('change', () => {
    document.querySelectorAll('.ph-photo-leaf').forEach(leaf => leaf.remove());
    enhance();
  }, options);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), {...options, once: true});
  else enhance();
})();
